import { render } from "./PanelAdminImportNext.vue?vue&type=template&id=74fd21f4&ts=true"
import script from "./PanelAdminImportNext.vue?vue&type=script&lang=ts"
export * from "./PanelAdminImportNext.vue?vue&type=script&lang=ts"

import "./PanelAdminImportNext.vue?vue&type=style&index=0&id=74fd21f4&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__